import { Link, useNavigate } from "react-router";

import { BrandLogo } from "@/components/brand-logo";
import { Button } from "@/components/ui/button";
import { useLogout, useMe, useWikiMe } from "@/lib/api";

// Constant-length JSX expression keeps prettier output stable for any rendered name.
const PROJECT_NAME = "BOI Marketing OS";

export function AppHeader() {
  const navigate = useNavigate();
  const logoutMutation = useLogout();
  const { data: me } = useMe();
  const { data: wikiMe } = useWikiMe();

  const pending = wikiMe?.pending_approvals ?? 0;

  const handleLogout = async () => {
    await logoutMutation.mutateAsync();
    navigate("/login");
  };

  return (
    <header className="border-border flex flex-wrap items-center justify-between gap-3 border-b px-6 py-4">
      <Link to="/home" aria-label="Home">
        <BrandLogo name={PROJECT_NAME} className="h-8 text-xl" />
      </Link>
      <nav className="flex flex-wrap items-center gap-2">
        <Link to="/approvals">
          <Button variant="ghost" size="sm">
            Approvals
            {pending > 0 && (
              <span className="bg-accent text-accent-foreground rounded-full px-2 py-0.5 text-xs font-medium">
                {pending}
              </span>
            )}
          </Button>
        </Link>
        {wikiMe?.is_wiki_admin && (
          <Link to="/usage">
            <Button variant="ghost" size="sm">
              Usage
            </Button>
          </Link>
        )}
        <Link to="/profile">
          <Button variant="ghost" size="sm">
            Profile
          </Button>
        </Link>
        {me?.role === "admin" && (
          <>
            <Link to="/admin/users">
              <Button variant="ghost" size="sm">
                Admin
              </Button>
            </Link>
            <Link to="/admin/activity">
              <Button variant="ghost" size="sm">
                Activity
              </Button>
            </Link>
          </>
        )}
        <Button variant="outline" size="sm" onClick={handleLogout}>
          Sign out
        </Button>
      </nav>
    </header>
  );
}
